// extracted by mini-css-extract-plugin
export default {"primaryColor":"#642472","mainTextColorOnPrimary":"#fff","version":"Version_version__WCRiv"};